<template>
  <v-form
    ref="form"
    v-model="valid"
    lazy-validation
    @submit.prevent="onConfirm"
  >
    <v-card tile>
      <v-card-title class="grey lighten-2">
        Ny Banner
      </v-card-title>
      <TibBannerForm :readonly="false" />
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer />
        <v-btn :disabled="pending" rounded @click="closeModal">Avbryt</v-btn>
        <v-btn rounded type="submit" color="primary" :loading="pending">
          Lägg till ärende
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import TibBannerForm from './form/TibBannerForm'
import CREATE_TIB_BANNER from '../graphql/createTibBanner.graphql'
import { get } from 'vuex-pathify'
import { v4 as uuidv4 } from 'uuid'

export default {
  name: 'TibBannerCreateModal',

  components: {
    TibBannerForm
  },

  data: () => ({
    valid: true,
    pending: false
  }),

  computed: {
    model: get('tibBanner/model')
  },

  methods: {
    async onConfirm() {
      const isValidForm = await this.$refs.form.validate()
      if (!isValidForm) return
      this.pending = true

      await this.$apollo.mutate({
        mutation: CREATE_TIB_BANNER,
        variables: {
          payload: {
            uuid: uuidv4(),
            time_start: new Date(this.model.time_start),
            time_end: new Date(this.model.time_end),
            text: this.model.text,
            reason: this.model.reason,
            train: this.model.train || '',
            title: this.model.title
          }
        }
      })
      await this.$store.dispatch(
        'tibBanner/fetch',
        this.$store.get('tibBanner/filter@date')
      )
      this.pending = false
      this.$store.set('tibBanner/selected', null)
      this.closeModal()
    },

    closeModal() {
      this.$emit('close')
      this.$store.dispatch('tibBanner/resetModel')
    }
  }
}
</script>
